import { jsxs, jsx } from 'react/jsx-runtime';
import authStatusConstants from '../../../constants/authStatusConstants.js';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import { containerStyle, fieldsetStyle, radioLabel } from '../styles.js';
var StubbedAuthSelector = function StubbedAuthSelector(_ref) {
  var stubbedAuthStatus = _ref.stubbedAuthStatus,
    stubbedStatus = _ref.stubbedStatus,
    _onChange = _ref.onChange,
    onConfirm = _ref.onConfirm;
  return jsxs("div", {
    style: containerStyle,
    children: [stubbedStatus === paymentStatus.CREATED && jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed 3DS options:"
      }), Object.values(authStatusConstants).map(function (status) {
        return jsxs("label", {
          style: radioLabel,
          children: [jsx("input", {
            type: "radio",
            name: "stubbedAuth",
            value: status,
            checked: stubbedAuthStatus === status,
            onChange: function onChange() {
              return _onChange(status);
            }
          }), status]
        }, status);
      })]
    }), jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed order options:"
      }), jsx("button", {
        onClick: onConfirm,
        children: "Place order and pay"
      })]
    })]
  });
};
export { StubbedAuthSelector as default };